import React, {useEffect, useReducer} from "react";
import {diff, keys, objectify} from 'radash'
import Link from "../widgets/Link";
import Toggle from "../widgets/Toggle";
import {
    addPrefixAndStateFilter,
    addStateFilter, addTaskKeyPrefixFilter,
    allStateFilters,
    removeAllFilters, removeStateFilter, removeTaskKeyPrefixFilter,
    setToggleAutoRefresh, setToggleShowAllTasks,
    setToggleTailLogs,
    taskTableReducer, toggleExpandRow
} from "./taskTableReducer";
import {useApi} from "../ApiSession";


export default ({pipelineInstance, tasks, onSelectTask, pauseRefresh}) => {

    const [taskTableView, taskTableDispatch] = useReducer(
        taskTableReducer,
        null,
        () => taskTableReducer(null, {name: "init", tasks, pipelineInstance})
    )


    const renderPopTaskLink = (taskKey, text) =>
        <Link onClick={() => onSelectTask(taskKey)}>{text}</Link>

    const renderSingleTaskRow = row =>
        <Tr
            key={row.rowId}
            row={row}
            onClick={() => onSelectTask(row.task.key)}
            taskTableView={taskTableView}
        >
            <td>
                <span style={{marginLeft: "1rem"}}>
                    {renderPopTaskLink(row.task.key, row.task.key)}
                </span>
            </td>
            <td></td>
            <td>
                <StateText state={row.task.state}/>
            </td>
            <td>
                {row.task.step}
            </td>
        </Tr>


    const renderAddTaskPrefixFilter = row => {

        if(taskTableView.taskKeyPrefixFilters.find(f => row.groupPrefix === f)) {
            return null
        }

        return <Link onClick={() => taskTableDispatch(addTaskKeyPrefixFilter(row.groupPrefix))}>filter</Link>
    }

    const renderMultiTaskRow = row => {

        if (!row.isExpanded) {

            return <Tr row={row} taskTableView={taskTableView} key={row.rowId}>
                <td>
                    <div className={"flex justify-left"}>
                        <div>
                            <AngleRight onClick={() => taskTableDispatch(toggleExpandRow(row))}/>
                        </div>
                        <div>
                            <span
                                onClick={() => taskTableDispatch(toggleExpandRow(row))}>
                                {row.groupPrefix}.*   <span className={"ml-2"}>{renderAddTaskPrefixFilter(row)}</span>
                            </span>
                        </div>
                    </div>
                </td>
                <td></td>
                <td>
                    {
                        row.statesWithCounts && row.statesWithCounts.map(swc =>
                            <div
                                key={swc.state}
                            >
                                <Link
                                    onClick={() => taskTableDispatch(addPrefixAndStateFilter(row.groupPrefix, swc.state))}
                                >
                                    <StateText state={swc.state}/>: {swc.taskCountInState} / {row.taskCount}
                                </Link>
                            </div>
                        )
                    }
                </td>
                <td></td>
            </Tr>
        }

        if (row.isFirst) {
            return <Tr row={row} taskTableView={taskTableView} key={row.rowId}>
                <td rowSpan={row.rowSpan}>
                    <div className={"flex justify-left"}>
                        <AngleDown onClick={() => taskTableDispatch(toggleExpandRow(row))}/>
                        <div
                            onClick={() => taskTableDispatch(toggleExpandRow(row))}
                        >
                            {row.groupPrefix}.*
                        </div>
                        <div className={"flex justify-left pl-2"}>
                            {renderAddTaskPrefixFilter(row)}
                        </div>
                    </div>
                </td>
                <td>
                    {renderPopTaskLink(row.task.key, row.keySuffix)}
                </td>
                <td>
                    <StateText state={row.task.state}/>
                </td>
                <td>
                    {row.task.step}
                </td>
            </Tr>
        }

        // expanded
        return <Tr row={row} onClick={() => onSelectTask(row.task.key)} taskTableView={taskTableView} key={row.rowId}>
            <td>
                {renderPopTaskLink(row.task.key, row.keySuffix)}
            </td>
            <td>
                <div>
                    <StateText state={row.task.state}/>
                </div>
            </td>
            <td>
                {row.task.step}
            </td>
        </Tr>
    }


    const renderFiltersLabel = () => {
        if (taskKeyPrefixFilters.length + stateFilters.length  === 0) {
            return null
        }
        return <div>Filters: </div>
    }

    return <div className="">
        <TableControlPanel
            taskTableView={taskTableView}
            taskTableDispatch={taskTableDispatch}
            pid={pipelineInstance.pid}
            pauseRefresh={pauseRefresh}
        />
        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-900 uppercase dark:text-gray-400">
                <tr>
                    <th colSpan={2}>Task</th>
                    <th>State</th>
                    <th>Step</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
            {
                taskTableView.rows.map(row => row.isSingleTaskGroup ? renderSingleTaskRow(row) : renderMultiTaskRow(row))
            }
            </tbody>
        </table>
    </div>
}


const TableControlPanel = ({taskTableView, taskTableDispatch, pid, pauseRefresh}) => {

    const api = useApi()

    const fetchTasksWithLogs = (taskTableView) => {
        const visibleTaskKeys =
            taskTableView.rows.filter(r => r.isSingleTaskGroup || r.isExpanded).map(r => r.task.key)

        const keysToFetch = diff(visibleTaskKeys, keys(taskTableView.lastLogsStoppedTasksPerKey))

        api.latestPipelineInstance(pid, keysToFetch).then(res => {
            taskTableDispatch({name: "refreshTasks", tasks: res.tasks})
        })
    }

    useEffect(() => {
        fetchTasksWithLogs(taskTableView)
    }, [taskTableView.isShowAllTasks])

    useEffect(() => {
        let interval;

        if (taskTableView.isAutoRefresh && (!pauseRefresh)) {
            interval = setInterval(() => {
                fetchTasksWithLogs(taskTableView)
            }, 5000)
        }
        return () => clearInterval(interval)
      }, [taskTableView.isAutoRefresh, taskTableView.c, pauseRefresh])

    const toggleTailLogs = () => {
        const newValue = !!!taskTableView.isTailLogs
        taskTableDispatch(setToggleTailLogs(newValue))
        if(newValue) {
            fetchTasksWithLogs(taskTableView)
        }
    }

    const toggleAutoRefresh = () => {
        const newValue = !!!taskTableView.isAutoRefresh
        taskTableDispatch(setToggleAutoRefresh(newValue))
        if(newValue) {
            fetchTasksWithLogs(taskTableView)
        }
    }

    const toggleShowAllTasks = () => {
        const newValue = !!!taskTableView.isShowAllTasks
        taskTableDispatch(setToggleShowAllTasks(newValue))
    }


    const renderClearAllFilters = () => {
        if (taskTableView.taskKeyPrefixFilters.length + taskTableView.stateFilters.length > 1) {
            return <div
                className={"mt-2 ml-4"}
                style={{cursor: "default"}}
            >
                <Link onClick={() => taskTableDispatch(removeAllFilters())}>remove all filters</Link>
            </div>
        }
    }

    const availableStateFilters = () =>
        diff(allStateFilters, taskTableView.stateFilters)

    const renderLeft = () => <>
        <div className={"mr-6"}>
            <select
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                onChange={e => {
                    if (e.target.value !== "") {
                        taskTableDispatch(addStateFilter(e.target.value))
                    }
                }}
                value={""}
            >
                <option value={""}>... add filter</option>
                {
                    availableStateFilters().map(state => <option key={state} value={state}>
                        {state}
                    </option>)
                }
            </select>
        </div>
        {
            taskTableView.stateFilters.map(state =>
                <Tag
                    key={state}
                    caption={<StateText state={state}/>}
                    onRemoveClick={() => taskTableDispatch(removeStateFilter(state))}
                />
            )
        }
        {
            taskTableView.taskKeyPrefixFilters.map(taskPrefix =>
                <Tag
                    key={taskPrefix}
                    caption={`${taskPrefix}.*`}
                    onRemoveClick={() => taskTableDispatch(removeTaskKeyPrefixFilter(taskPrefix))}
                />
            )
        }
        {
            renderClearAllFilters()
        }
    </>

    return <div className={"grid grid-cols-2"}>
        <div className={"flex justify-start p-4"}>
            {renderLeft()}
        </div>
        <div className={"flex justify-end p-4 gap-3"}>
            <div>
                <Toggle
                    label={"show all tasks"}
                    value={taskTableView.isShowAllTasks}
                    onChange={toggleShowAllTasks}
                />
            </div>
            <div>
                <Toggle
                    label={"auto refresh"}
                    value={taskTableView.isAutoRefresh}
                    onChange={toggleAutoRefresh}
                />
            </div>
            <div>
                <Toggle
                    label={"tail logs"}
                    value={taskTableView.isTailLogs}
                    onChange={toggleTailLogs}
                />
            </div>
        </div>
    </div>
}


const Tag = ({caption, onRemoveClick}) =>
    <span
        className="inline-flex items-center px-2 py-1 me-2 text-sm font-medium text-gray-800 bg-gray-100 rounded-lg dark:bg-gray-700 dark:text-gray-300 border border-gray-500">
                {caption}
        <button type="button"
                onClick={onRemoveClick}
                className="inline-flex items-center p-1 ms-2 text-sm text-gray-400 bg-transparent rounded-xs hover:bg-gray-200 hover:text-gray-900 dark:hover:bg-gray-600 dark:hover:text-gray-300"
                data-dismiss-target="#badge-dismiss-dark"
                aria-label="Remove"
        >
                <svg className="w-2 h-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                     viewBox="0 0 14 14">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                </svg>
                    <span className="sr-only">Remove badge</span>
                </button>
    </span>


const takeRight = (a, n) =>
    a.slice(Math.max(a.length - n, 0))


const Tr = ({children, row, onClick, taskTableView}) => {

    const renderLogTail = () => {

        if (!row.task) {
            return null
        }


        const log = taskTableView.lastLogsStoppedTasksPerKey[row.task.key] || row.task.log

        if (!log) {
            return null
        }

        if (taskTableView.isTailLogs && (row.isSingleTaskGroup || row.isExpanded)) {

            const lines = log.split("\n")
            return <div>
                {takeRight(lines, 3).map(l => l.substring(0, 100)).join("\n")}
            </div>
        }
    }

    return <tr
        onClick={onClick}
        className={`bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200 ${row.isExpanded ? 'hover:underline' : ''}`}
        style={{cursor: "default"}}
    >
        {children}
        <td
            style={{width: "50%"}}
        >
            {renderLogTail()}
        </td>
    </tr>
}

const AngleRight = ({onClick}) =>
    <svg
        onClick={onClick}
        className="w-5 h-5 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
        width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="m9 5 7 7-7 7"/>
    </svg>

const AngleDown = ({onClick}) =>
    <svg
        onClick={onClick}
        className="w-5 h-5 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
         width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="m19 9-7 7-7-7"/>
    </svg>


const StateText = ({state}) => {

    const col = () => {
        switch (state) {
            case "failed": return "text-red-700"
            case "started": return "text-green-700"
            case "completed": return "text-gray-700"
            default: return ""
        }
    }

    return <span className={`font-semibold ${col()}`}>
        {state}
    </span>
}
